import {EffectsModule} from "@ngrx/effects";
import {StoreModule} from "@ngrx/store";
import {isDevMode, NgModule} from "@angular/core";
import {metaReducers, reducers} from "./reducers";
import {
  CaseEntitiesEffects,
  DashboardEffects,
  DocumentsEffects,
  FiusEffects,
  NotificationsEffects,
  RelatedCasesEffects,
  RolesEffects,
  UsersEffects,
  WorkingGroupsEffects,
  CountriesEffects,
} from "./effects";
import {StoreDevtoolsModule} from "@ngrx/store-devtools";

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([
      RolesEffects,
      UsersEffects,
      DocumentsEffects,
      DashboardEffects,
      FiusEffects,
      CaseEntitiesEffects,
      WorkingGroupsEffects,
      RelatedCasesEffects,
      NotificationsEffects,
      CountriesEffects
    ]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: !isDevMode(),
    }),
  ],
  exports: [],
  providers: []
})

export class GIZStoreModule {
}
